import { useContext } from 'react';
import { WarningProvider } from './WarningProvider';

export const useWarning = () => {
  return useContext(WarningProvider.Context);
};
